// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1l5jh","col":"styles_col__2yuX_","actions":"styles_actions__e-KLg","conflict":"styles_conflict__3IhHJ"};